import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

const BASEURL = environment.apiBase;

@Injectable({
  providedIn: 'root'
})

export class ReferenceService {

  constructor(private http: HttpClient) { }
  public checkRerefences(reference:string) {
    return this.http.post(`${BASEURL}/api/references`, {search: {reference}}, {
      responseType: 'json'
    })/* .pipe(
      //tap(_ => console.log('sí se pudo')),
      catchError(this.handleRegisterError<any>('checkIfEmailExist', []))
    ); */
  }
}
